// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I6Qs","index":"styles_index__1WZes"};